<template>
  <div class="container">
    <div class="select-container">
      <div class="close-btn" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'window-close']" />
      </div>
      <div class="content">
        <div class="row header">
          <p class="w10 flex">Current</p>
          <p class="w10 flex">ID</p>
          <p class="w30 flex">Name</p>
          <p class="w20 flex">Last Edited</p>
          <p class="w20 flex">Default for</p>
          <p class="w10 flex">Actions</p>
        </div>
        <div
          @click="!layout.current ? openBoard(layout.id) : ''"
          :class="{ selected: layout.current }"
          class="row selection"
          v-for="layout in filteredLayouts"
          :key="layout.id"
        >
          <p class="w10 flex">
            <font-awesome-icon :icon="['fa', 'check']" v-if="layout.current" />
          </p>
          <p class="w10 flex">{{ layout.id }}</p>
          <p class="w30 flex">{{ layout.name }}</p>
          <p class="w20 flex">
            {{ new Date(layout.lastEdited).toLocaleString() }}
          </p>
          <p class="w20 flex">{{ layout.defaultFor }}</p>
          <p class="w10 flex" @click.stop="deleteLayout(layout.id)">
            <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </p>
        </div>
      </div>
    </div>
    <popup ref="confirm"></popup>
  </div>
</template>

<script>
export default {
  computed: {
    filteredLayouts() {
      var boards = this.$store.getters.layoutCollection;
      var index = boards.findIndex(
        (x) => x.id == this.$store.getters.currentLayout
      );

      if (index != -1) {
        boards[index].current = true;
      }
      
      return boards;
    },
  },

  mounted() {
    this.$diamond.getDashboardLayouts().then((res) => {
      this.$store.commit("setLayoutCollection", res.data);
    });
  },

  methods: {
    openBoard(id) {
      this.$emit("loadLayout", id);
      this.$emit("close");
    },

    async deleteLayout(id) {
      var confirm = await this.$refs.confirm.show({
        title: "Delete layout",
        message: `Are you sure you want to delete the layout with id ${id}?`,
        okButton: "Delete",
        isConfirm: true,
      });

      if (confirm) {
        this.$diamond.deleteLayout(id).then(() => {
          this.$toast("success", `Layout with id ${id} deleted successfully.`);
          this.$diamond.getDashboardLayouts().then((res) => {
          this.$store.commit("setLayoutCollection", res.data);
          });
        })
        .catch(() => {
         // On unsuccessful deletion
         this.$toast("error", `Layout with ID ${id} is not deleted. You do not have permissions.`);
        });
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: rgba(48, 48, 48, 0.35);
}

.select-container {
  min-height: 30vh;
  min-width: 50vw;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-height: 90%;
  overflow-y: scroll;
}

.close-btn {
  align-self: flex-end;
  cursor: pointer;
}

.row {
  display: flex;
  width: 100%;
  padding: 10px 0;
}

.header {
  border-bottom: 1px solid #303030;
}

.w10 {
  width: 10%;
}

.w20 {
  width: 20%;
}

.w30 {
  width: 30%;
}

.w40 {
  width: 40%;
}

.selection:hover {
  background-color: rgba(48, 48, 48, 0.2);
  cursor: pointer;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected {
  background-color: rgb(216, 216, 216);
  cursor: default !important;
  color: #797979;
}
</style>